export var groupMarksByPosition = function (marks) {
    var groups = {};
    marks.forEach(function (mark) {
        var x = mark.x;
        if (!groups[x])
            groups[x] = [];
        groups[x].push(mark);
    });
    return groups;
};
export var findMarksInCluster = function (mark, marks, range) {
    if (range === void 0) { range = 10; }
    var x = mark.x, y = mark.y;
    var group = marks[x];
    return group.filter(function (mark) { return Math.abs(y - mark.y) < range; });
};
export var showAllMarks = function (stepMode, marks, lines) {
    if (marks.length && lines.length)
        return stepMode || marks[0].radius <= lines[0].strokeWidth / 2;
    return false;
};
export var generateLineMarks = function (data, xScale, yScale, labelSelector, color, keyName, markRadius) {
    var marks = [];
    data.forEach(function (_d, index) {
        var _a;
        var value = (_a = data[index]) === null || _a === void 0 ? void 0 : _a[keyName];
        if (keyName !== labelSelector) {
            var mark = {
                key: index + "." + keyName + ".mark",
                dataSerieKey: keyName,
                color: color,
                selector: [index, keyName],
                x: xScale(data[index][labelSelector]),
                y: yScale(value),
                radius: markRadius,
            };
            marks.push(mark);
        }
    });
    return marks;
};
